import React from 'react';
import { DATE_STEPS, DIFF_PROPS, isDivergingProp } from '../lib/inversion-results';

/**
 * TimelapseDateSlider — a three-position slider over a time-lapse difference model:
 * Model A (the earlier state) / Difference / Model B (the later state).
 *
 * Props:
 *   model     - the `timelapse-diff` model ({ parents: { a_name, b_name } })
 *   property  - the property currently shown (resistivity_a | resistivity_b | a diverging difference)
 *   onChange(property) - called with the property of the chosen step
 *   C         - theme colours
 */
export default function TimelapseDateSlider({ model, property, onChange, C }) {
  const idx = property === 'resistivity_a' ? 0 : property === 'resistivity_b' ? 2 : 1;
  const names = [model?.parents?.a_name || 'Model A', 'Difference (B − A)', model?.parents?.b_name || 'Model B'];
  const diffProp = isDivergingProp(property) ? property : DATE_STEPS[1].prop;
  return (
    <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 8 }}>
      <div style={{ fontSize: 10, fontWeight: 600, color: C.text2, textTransform: 'uppercase', marginBottom: 4 }}>Time-lapse</div>
      <input type="range" min={0} max={2} step={1} value={idx} aria-label="Time-lapse step"
        onChange={(e) => {
          const i = parseInt(e.target.value, 10);
          onChange(i === 0 ? DATE_STEPS[0].prop : i === 2 ? DATE_STEPS[2].prop : diffProp);
        }}
        style={{ width: '100%', accentColor: C.cyan }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 9, color: C.text3 }}>
        {names.map((n, i) => (
          <span key={n} style={{ color: i === idx ? C.cyan : C.text3, fontWeight: i === idx ? 600 : 400, maxWidth: '33%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n}</span>
        ))}
      </div>
      {idx === 1 && (
        <select value={diffProp} onChange={(e) => onChange(e.target.value)} aria-label="Difference measure"
          style={{ width: '100%', marginTop: 4, fontSize: 10, padding: '3px 6px', borderRadius: 6, background: C.bg4, border: `1px solid ${C.border}`, color: C.text0 }}>
          {DIFF_PROPS.filter((p) => p.diverging).map((p) => <option key={p.id} value={p.id}>{p.label}</option>)}
        </select>
      )}
    </div>
  );
}
